import { useOutsideClick } from "hooks";
import { useEffect, useState } from "react";
import { useAppSelector } from "store/hooks";
import { userSettingState } from "store/selectors";
import { PhoneInputField, PhoneInputFieldWithValidation } from "components/ui";
import { fetchMatchingLeads, getLeadOptions } from "utils/helpers";
import { useDebounce } from "hooks";
import styles from "./styles.module.css";

export function CustomSelectwithPhoneInput({
  onBlur,
  error,
  onChange,
  value,
  classes,
  disabled = false,
}: any) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<any>(null);
  const [matchingLeads, setMatchingLeads] = useState<any>([]);
  const { isDarkMode } = useAppSelector(userSettingState);
  const debouncedValue = useDebounce(value, 500);
  const ref = useOutsideClick(() => {
    setIsOpen(false);
  });

  useEffect(() => {
    const option = options.find((item: any) => item.label === value);
    setSelectedOption(option);
  }, [value]);

  useEffect(() => {
    fetchLeadsOptions(debouncedValue);
  }, [debouncedValue]);

  async function fetchLeadsOptions(phoneNumber: any) {
    const response: any = await fetchMatchingLeads({ phoneNumber });

    setMatchingLeads(response?.data);
  }

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option: any) => {
    setSelectedOption(option);

    onChange(option?.label, { isValid: true });
    setIsOpen(false);
  };

  const options = getLeadOptions(matchingLeads);

  return (
    <div
      className={`${styles.selectMain} ${
        isDarkMode ? styles.darkMode : ""
      } ${classes}`}
      ref={ref}
    >
      <button
        type="button"
        className={`${styles.selectBtn} ${
          !selectedOption && styles.placeholder
        }`}
        onClick={toggleDropdown}
        style={{
          pointerEvents: disabled ? "none" : "all",
        }}
      >
        {/* {selectedOption ? selectedOption.label : placeholder} */}
        {/* <PhoneInputField
          placeholder="+92XXXXXXXXXX"
          onChange={onChange}
          value={value}
          disabled={disabled}
        /> */}

        <PhoneInputFieldWithValidation
          onBlur={onBlur}
          onChange={onChange}
          value={value}
          disabled={disabled}
          error={error}
        />
      </button>

      {isOpen && (
        <ul className={`${styles.optionsList}`}>
          {options?.length ? (
            options.map((option: any) => (
              <li
                key={option.value + option?.lead_id}
                className={`${styles.option} ${
                  selectedOption && selectedOption.value === option.value
                    ? styles.active
                    : ""
                }`}
                onClick={() => handleOptionClick(option)}
              >
                {option.label}
              </li>
            ))
          ) : (
            <li className="text-red-500 p-2">Not Available</li>
          )}
        </ul>
      )}
    </div>
  );
}

export function CustomSelectwithPhoneInputReturnObj({
  onBlur,
  error,
  onChange,
  value,
  classes,
  disabled = false,
}: any) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<any>(null);
  const [matchingLeads, setMatchingLeads] = useState<any>([]);
  const { isDarkMode } = useAppSelector(userSettingState);
  const debouncedValue = useDebounce(value, 500);
  const ref = useOutsideClick(() => {
    setIsOpen(false);
  });

  useEffect(() => {
    const option = options.find((item: any) => item.label === value);
    setSelectedOption(option);
  }, [value]);

  useEffect(() => {
    fetchLeadsOptions(debouncedValue);
  }, [debouncedValue]);

  async function fetchLeadsOptions(phoneNumber: any) {
    const response: any = await fetchMatchingLeads({ phoneNumber });

    setMatchingLeads(response?.data);
  }

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option: any) => {
    setSelectedOption(option);
    onChange(option, { isValid: true });
    setIsOpen(false);
  };

  const options = getLeadOptions(matchingLeads);

  return (
    <div
      className={`${styles.selectMain} ${
        isDarkMode ? styles.darkMode : ""
      } ${classes}`}
      ref={ref}
    >
      <button
        type="button"
        className={`${styles.selectBtn} ${
          !selectedOption && styles.placeholder
        }`}
        onClick={toggleDropdown}
        style={{
          pointerEvents: disabled ? "none" : "all",
        }}
      >
        {/* {selectedOption ? selectedOption.label : placeholder} */}
        {/* <PhoneInputField
          placeholder="+92XXXXXXXXXX"
          onChange={onChange}
          value={value}
          disabled={disabled}
        /> */}

        <PhoneInputFieldWithValidation
          onBlur={onBlur}
          onChange={onChange}
          value={value}
          disabled={disabled}
          error={error}
        />
      </button>

      {isOpen && (
        <ul className={`${styles.optionsList}`}>
          {options?.length ? (
            options.map((option: any) => (
              <li
                key={option.value + option?.lead_id}
                className={`${styles.option} ${
                  selectedOption && selectedOption.value === option.value
                    ? styles.active
                    : ""
                }`}
                onClick={() => handleOptionClick(option)}
              >
                {option.label}
              </li>
            ))
          ) : (
            <li className="text-red-500 p-2">Not Available</li>
          )}
        </ul>
      )}
    </div>
  );
}
